// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"6425374e","70":"276d51c2","92":"12ba95a1","307":"4c4de586","399":"918e2907","407":"1a41eda2","449":"9304b367","455":"8d469397"}[chunkId] + ".chunk.js";
};